export let RemainingCreditReportSortColumnId = /*#__PURE__*/function (RemainingCreditReportSortColumnId) {
  RemainingCreditReportSortColumnId["CompanyName"] = "companyName";
  RemainingCreditReportSortColumnId["AgreementName"] = "agreementName";
  RemainingCreditReportSortColumnId["ServiceName"] = "serviceName";
  RemainingCreditReportSortColumnId["Amount"] = "amount";
  return RemainingCreditReportSortColumnId;
}({});